 (function() {
    class premium_Shopify_DataLayer {
    constructor() {
        window.dataLayer = window.dataLayer || []; 
        
        // use prefix of events name
        this.eventPrefix = '';

        // keep the value false to get non-formatted product id
        this.formattedItemId = true; 

        // add to wishlist selectors
        this.addToWishListSelectors = {
        'addWishListIcon': '',
        'gridItemSelector': '',
        'productLinkSelector': 'a[href*="/products/"]'
        }

        // quick view selectors
        this.quickViewSelector = {
        'quickViewElement': '',
        'gridItemSelector': '',
        'productLinkSelector': 'a[href*="/products/"]'
        }

        // mini cart button selector
        this.miniCartButton = [
        'a[href="/cart"]', 
        ];
        this.miniCartAppersOn = 'click';


        // begin checkout buttons/links selectors
        this.beginCheckoutButtons = [
        'input[name="checkout"]',
        'button[name="checkout"]',
        'a[href="/checkout"]',
        '.additional-checkout-buttons',
        ];

        // direct checkout button selector
        this.shopifyDirectCheckoutButton = [
        '.shopify-payment-button'
        ]

        // keep the value true if Add to Cart redirect to cart page
        this.isAddToCartRedirect = false;
        
        // keep the value false if cart items increment/decrement/remove refresh page 
        this.isAjaxCartIncrementDecrement = true;
        

        // Caution: Do not modify anything below this line, as it may result in it not functioning correctly.
        this.cart = null
        this.countryCode = "";
        this.collectData();  
    }

    updateCart() {
        fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
        this.cart = data;
        });
    }

    debounce(delay) {         
        let timeoutId;
        return function(func) {
        console.log('on-clean', timeoutId);
        const context = this;
        const args = arguments;
        
        clearTimeout(timeoutId);
        
        timeoutId = setTimeout(function() {
            func.apply(context, args);
        }, delay);

        console.log('new set', timeoutId);
        };
    }

    collectData() { 
        this.customerData();
        this.ajaxRequestData();
        this.searchPageData();
        this.miniCartData();
        this.beginCheckoutData();

        

        

        
        
        this.addToWishListData();
        this.quickViewData();
        this.formData();
        this.phoneClickData();
        this.emailClickData();
    }        

    //logged in customer data 
    customerData() {
        const currentUser = {};
        

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            customer: currentUser
        })
    }

    // add_to_cart, remove_from_cart, search
    ajaxRequestData() {
        const self = this;
        
        // handle non-ajax add to cart
        if(this.isAddToCartRedirect) {
        document.addEventListener('submit', function(event) {
            const addToCartForm = event.target.closest('form[action="/cart/add"]');
            if(addToCartForm) {
            event.preventDefault();
            
            const formData = new FormData(addToCartForm);
        
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                window.location.href = "";
            })
            .catch((error) => {
                console.error('Error:', error);
            });
            }
        });
        }
        
        // fetch
        let originalFetch = window.fetch;
        let debounce = this.debounce(800);
        
        window.fetch = function () {
        return originalFetch.apply(this, arguments).then((response) => {
            if (response.ok) {
            let cloneResponse = response.clone();
            let requestURL = arguments[0];
            
            if(/.*\/search\/?.*\?.*q=.+/.test(requestURL)) {   
                const queryString = requestURL.split('?')[1];
                const urlParams = new URLSearchParams(queryString);
                const search_term = urlParams.get("q");

                debounce(function() {
                dataLayer.push({
                    event: 'search', 
                    search_term
                })
                });
            }
            else if (requestURL.includes("/cart/add")) {
                cloneResponse.text().then((text) => {
                let item = JSON.parse(text);
                self.singleCartItemDataLayer('add_to_cart', item);
                self.updateCart();
                });
            }else if(requestURL.includes("/cart/change")) {
                
                cloneResponse.text().then((text) => {
                    
                let newCart = JSON.parse(text);
                let newCartItems = newCart.items;
                let oldCartItems = self.cart.items;

                for(let i = 0; i < oldCartItems.length; i++) {
                    let item = oldCartItems[i];
                    let newItem = newCartItems.find(newItems => newItems.id === item.id);


                    if(newItem) {

                    if(newItem.quantity > item.quantity) {
                        // cart item increment
                        let quantity = (newItem.quantity - item.quantity);
                        let updatedItem = {...item, quantity}
                        self.singleCartItemDataLayer('add_to_cart', updatedItem);
                        self.updateCart(); 

                    }else if(newItem.quantity < item.quantity) {
                        // cart item decrement
                        let quantity = (item.quantity - newItem.quantity);
                        let updatedItem = {...item, quantity}
                        self.singleCartItemDataLayer('remove_from_cart', updatedItem);
                        self.updateCart(); 
                    }
                    

                    }else {
                    self.singleCartItemDataLayer('remove_from_cart', item);
                    self.updateCart(); 
                    }
                }
                    
                });
            }
            }
            return response;
        });
        }
        // end fetch 


        //xhr
        var origXMLHttpRequest = XMLHttpRequest;
        XMLHttpRequest = function() {
        var requestURL;

        var xhr = new origXMLHttpRequest();
        var origOpen = xhr.open;
        var origSend = xhr.send;
        


        // Override the `open` function.
        xhr.open = function(method, url) {
            requestURL = url;
            return origOpen.apply(this, arguments);
        };


        xhr.send = function() {

            // Only proceed if the request URL matches what we're looking for.
            if (requestURL.includes("/cart/add") || requestURL.includes("/cart/change") || /.*\/search\/?.*\?.*q=.+/.test(requestURL)) {
    
                xhr.addEventListener('load', function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status >= 200 && xhr.status < 400) { 

                            if(/.*\/search\/?.*\?.*q=.+/.test(requestURL)) {
                            const queryString = requestURL.split('?')[1];
                            const urlParams = new URLSearchParams(queryString);
                            const search_term = urlParams.get("q");

                            debounce(function() {
                                dataLayer.push({
                                event: 'search', 
                                search_term
                                })
                            });
                            }

                            else if(requestURL.includes("/cart/add")) {
                                
                                const item = JSON.parse(xhr.responseText);
                                self.singleCartItemDataLayer('add_to_cart', item);
                                self.updateCart();
                                
                            }else if(requestURL.includes("/cart/change")) {
                                
                                const newCart = JSON.parse(xhr.responseText);
                                const newCartItems = newCart.items;
                                let oldCartItems = self.cart.items;
            
                                for(let i = 0; i < oldCartItems.length; i++) {
                                let item = oldCartItems[i];
                                let newItem = newCartItems.find(newItems => newItems.id === item.id);
            
            
                                if(newItem) {
                                    if(newItem.quantity > item.quantity) {
                                    // cart item increment
                                    let quantity = (newItem.quantity - item.quantity);
                                    let updatedItem = {...item, quantity}
                                    self.singleCartItemDataLayer('add_to_cart', updatedItem);
                                    self.updateCart(); 
            
                                    }else if(newItem.quantity < item.quantity) {
                                    // cart item decrement
                                    let quantity = (item.quantity - newItem.quantity);
                                    let updatedItem = {...item, quantity}
                                    self.singleCartItemDataLayer('remove_from_cart', updatedItem);
                                    self.updateCart(); 
                                    }
                                    
            
                                }else {
                                    self.singleCartItemDataLayer('remove_from_cart', item);
                                    self.updateCart(); 
                                }
                                }
                            }          
                        }
                    }
                });
            }

            return origSend.apply(this, arguments);
        };

        return xhr;
        }; 
        //end xhr
    }

    // search event from search page
    searchPageData() {
        let pageUrl = window.location.href;
        if(/.*\/search\/?.*\?q=.+/.test(pageUrl)) {   
        const queryString = pageUrl.split('?')[1];
        const urlParams = new URLSearchParams(queryString);
        const search_term = urlParams.get("q");

        if (performance.navigation.type === 0) {
            dataLayer.push({
                event: 'search', 
                search_term
            });
        }
        }
    }

    // view_cart
    miniCartData() {
        if(this.miniCartButton.length) {
        let self = this;
        if(this.miniCartAppersOn === 'hover') {
            this.miniCartAppersOn = 'mouseenter';
        }
        this.miniCartButton.forEach((selector) => {
        let miniCartButton = document.querySelector(selector);

            if(miniCartButton) {
            miniCartButton.addEventListener(self.miniCartAppersOn, () => {
                self.cartItemsDataLayer('view_cart', self.cart);
            });
            }
        });
        }
    }

    // begin_checkout
    beginCheckoutData() {
        let self = this;
        document.addEventListener('click', () => {
        let targetElement = event.target.closest(self.beginCheckoutButtons.join(', '));
        if(targetElement) {
            self.cartItemsDataLayer('begin_checkout', self.cart);
        }
        });
    }

    // view_cart, add_to_cart, remove_from_cart
    viewCartPageData() {
        
        this.cartItemsDataLayer('view_cart', this.cart);

        //if cart quantity chagne reload page 
        if(!this.isAjaxCartIncrementDecrement) {
        const self = this;
        document.addEventListener('pointerdown', (event) => {
            const target = event.target.closest('a[href*="/cart/change?"]');
            if(target) {
            const linkUrl = target.getAttribute('href');
            const queryString = linkUrl.split("?")[1];
            const urlParams = new URLSearchParams(queryString);
            const newQuantity = urlParams.get("quantity");
            const line = urlParams.get("line");
            const cart_id = urlParams.get("id");
    
            
            if(newQuantity && (line || cart_id)) {
                let item = line ? {...self.cart.items[line - 1]} : self.cart.items.find(item => item.key === cart_id);
    
                let event = 'add_to_cart';
                if(newQuantity < item.quantity) {
                event = 'remove_from_cart';
                }
    
                let quantity = Math.abs(newQuantity - item.quantity);
                item['quantity'] = quantity;
    
                self.singleCartItemDataLayer(event, item);
            }
            }
        });
        }
    }

    productSinglePage() {
    
    }

    collectionsPageData() {
        var ecommerce = {
        'items': [
            
            ]
        };

        ecommerce['item_list_id'] = null
        ecommerce['item_list_name'] = null

        this.cartItemsDataLayer('view_item_list', ecommerce);
    }
    
    
    // add to wishlist
    addToWishListData() {
        if(this.addToWishListSelectors && this.addToWishListSelectors.addWishListIcon) {
        const self = this;
        document.addEventListener('pointerdown', (event) => {
            let target = event.target;
            
            if(target.closest(self.addToWishListSelectors.addWishListIcon)) {
            let pageULR = window.location.href.replace(/\?.+/, '');
            let requestURL = undefined;
        
            if(/\/products\/[^/]+$/.test(pageULR)) {
                requestURL = pageULR;
            } else if(self.addToWishListSelectors.gridItemSelector && self.addToWishListSelectors.productLinkSelector) {
                let itemElement = target.closest(self.addToWishListSelectors.gridItemSelector);
                if(itemElement) {
                let linkElement = itemElement.querySelector(self.addToWishListSelectors.productLinkSelector); 
                if(linkElement) {
                    let link = linkElement.getAttribute('href').replace(/\?.+/g, '');
                    if(link && /\/products\/[^/]+$/.test(link)) {
                    requestURL = link;
                    }
                }
                }
            }

            if(requestURL) {
                fetch(requestURL + '.json')
                .then(res => res.json())
                .then(result => {
                    let data = result.product;                    
                    if(data) {
                    let dataLayerData = {
                        product_id: data.id,
                        variant_id: data.variants[0].id,
                        product_title: data.title,
                        quantity: 1,
                        final_price: parseFloat(data.variants[0].price) * 100,
                        total_discount: 0,
                        product_type: data.product_type,
                        vendor: data.vendor,
                        variant_title: (data.variants[0].title !== 'Default Title') ? data.variants[0].title : undefined,
                        sku: data.variants[0].sku,
                    }

                    self.singleCartItemDataLayer('add_to_wishlist', dataLayerData);
                    }
                });
            }
            }
        });
        }
    }

    quickViewData() {
        if(this.quickViewSelector.quickViewElement && this.quickViewSelector.gridItemSelector && this.quickViewSelector.productLinkSelector) {
        const self = this;
        document.addEventListener('pointerdown', (event) => {
            let target = event.target;
            if(target.closest(self.quickViewSelector.quickViewElement)) {
            let requestURL = undefined;
            let itemElement = target.closest(this.quickViewSelector.gridItemSelector );
            
            if(itemElement) {
                let linkElement = itemElement.querySelector(self.quickViewSelector.productLinkSelector); 
                if(linkElement) {
                let link = linkElement.getAttribute('href').replace(/\?.+/g, '');
                if(link && /\/products\/[^/]+$/.test(link)) {
                    requestURL = link;
                }
                }
            }   
            
            if(requestURL) {
                fetch(requestURL + '.json')
                    .then(res => res.json())
                    .then(result => {
                    let data = result.product;                    
                    if(data) {
                        let dataLayerData = {
                        product_id: data.id,
                        variant_id: data.variants[0].id,
                        product_title: data.title,
                        quantity: 1,
                        final_price: parseFloat(data.variants[0].price) * 100,
                        total_discount: 0,
                        product_type: data.product_type,
                        vendor: data.vendor,
                        variant_title: (data.variants[0].title !== 'Default Title') ? data.variants[0].title : undefined,
                        sku: data.variants[0].sku,
                        }

                        self.singleCartItemDataLayer('view_item', dataLayerData);
                        self.quickViewVariants = data.variants;
                        self.quickViewedItem = dataLayerData;
                    }
                    });
                }
            }
        });

        
            if(this.shopifyDirectCheckoutButton.length) {
            let self = this;
            document.addEventListener('pointerdown', (event) => {
                let target = event.target;
                let checkoutButton = event.target.closest(this.shopifyDirectCheckoutButton.join(', '));
                
                if(self.quickViewVariants && self.quickViewedItem && self.quickViewVariants.length && checkoutButton) {

                let checkoutForm = checkoutButton.closest('form[action*="/cart/add"]');
                if(checkoutForm) {
                    let quantity = 1;
                    let varientInput = checkoutForm.querySelector('input[name="id"]');
                    let quantitySelector = checkoutForm.getAttribute('id');

                    if(quantitySelector) {
                        let quentityInput = document.querySelector('input[name="quantity"][form="'+quantitySelector+'"]');
                        if(quentityInput) {
                            quantity = +quentityInput.value;
                        }
                    }

                    if(varientInput) {
                        let variant_id = parseInt(varientInput.value);

                        if(variant_id) {
                            const variant = self.quickViewVariants.find(item => item.id === +variant_id);
                            if(variant && self.quickViewedItem) {
                                self.quickViewedItem['variant_id'] = variant_id;
                                self.quickViewedItem['variant_title'] = variant.title;
                                self.quickViewedItem['final_price'] = parseFloat(variant.price) * 100;
                                self.quickViewedItem['quantity'] = quantity; 

                                self.singleCartItemDataLayer('add_to_cart', self.quickViewedItem);
                                self.singleCartItemDataLayer('begin_checkout', self.quickViewedItem);
                            }
                        }
                    }
                }

                }
            }); 
        }
        
        }
    }

    // single item add in dataLyaer
    singleCartItemDataLayer(event, item) { 
        dataLayer.push({ "ecommerce": null });
        const dataLayerData = {
        "event": this.eventPrefix + event,
        "ecommerce": {
            "currency": this.cart.currency,
            "value": +(((item.final_price / 100) * item.quantity).toFixed(2)),
            "items": [{
                "item_id": this.formattedItemId  ? `shopify_${this.countryCode}_${item.product_id}_${item.variant_id}` : item.product_id.toString(),
                "variant_id": item.variant_id.toString(),
                "item_name": item.product_title,
                "quantity": item.quantity,
                "price": +((item.final_price / 100).toFixed(2)),
                "discount": item.total_discount ? +((item.total_discount / 100).toFixed(2)) : 0
            }]
        }
        }

        if(item.product_type) {
        dataLayerData.ecommerce['items'][0]['item_category'] = item.product_type;
        }

        if(item.vendor) {
        dataLayerData.ecommerce['items'][0]['item_brand'] = item.vendor;
        }

        if(item.variant_title && item.variant_title !== 'Default Title') {
        dataLayerData.ecommerce['items'][0]['item_variant'] = item.variant_title;
        }

        if(item.sku) {
        dataLayerData.ecommerce['items'][0]['sku'] = item.sku;
        }

        if(item.item_list_id) {
        dataLayerData.ecommerce['items'][0]['item_list_id'] = item.item_list_id;
        }
        
        if(item.item_list_name) {
        dataLayerData.ecommerce['items'][0]['item_list_name'] = item.item_list_name;
        }
        
        dataLayer.push(dataLayerData);
    };

    // multiple items add in dataLayer
    cartItemsDataLayer(event, cart) {
        dataLayer.push({ 'ecommerce': null });
        const dataLayerData = {
        "event": this.eventPrefix + event,
        'ecommerce': {
            'currency': this.cart.currency,
            'items': cart.items.map((item, index) => {
                const itemDataLayerData = {
                'index': index,
                'item_id': this.formattedItemId  ? `shopify_${this.countryCode}_${item.product_id}_${item.variant_id}` : item.product_id.toString(),
                'variant_id': item.variant_id.toString(),
                'item_name': item.product_title,
                'quantity': item.quantity,
                'price': +((item.final_price / 100).toFixed(2)),
                'discount': item.total_discount ? +((item.total_discount / 100).toFixed(2)) : 0 
            }

            if(item.product_type) {
                itemDataLayerData['item_category'] = item.product_type;
            }
            
                if(item.vendor) {
                itemDataLayerData['item_brand'] = item.vendor;
            }

                                
            if(item.variant_title && item.variant_title !== 'Default Title') {
                itemDataLayerData['item_variant'] = item.variant_title;
            }
            
            if(item.sku) {
                itemDataLayerData['sku'] = item.sku;
            }

            if(item.item_list_name) {
                itemDataLayerData['item_list_name'] = item.item_list_name;
            }

            if(item.item_list_id) {
                itemDataLayerData['item_list_id'] = item.item_list_id;
            }

            return itemDataLayerData;
            })
        }
        }

        if(cart.total_price) {
        dataLayerData['ecommerce']['value'] = +((cart.total_price / 100).toFixed(2))
        }
        
        if(cart.item_list_id) {
        dataLayerData['ecommerce']['item_list_id'] = cart.item_list_id;
        }
        
        if(cart.item_list_name) {
        dataLayerData['ecommerce']['item_list_name'] = cart.item_list_name;
        }
        
        dataLayer.push(dataLayerData);
    }

    
    // contact form submit & newsletters signup
    formData() {
        const self = this;
        document.addEventListener('submit', function(event) {

        let targetForm = event.target.closest('form[action^="/contact"]');


        if(targetForm) {
            const formData = {
            form_location: window.location.href,
            form_id: targetForm.getAttribute('id'),
            form_classes: targetForm.getAttribute('class')
            };
                        
            let formType = targetForm.querySelector('input[name="form_type"]');
            let inputs = targetForm.querySelectorAll("input:not([type=hidden]):not([type=submit]), textarea, select");
            
            inputs.forEach(function(input) {
            var inputName = input.name;
            var inputValue = input.value;
            
            if (inputName && inputValue) {
                var matches = inputName.match(/\[(.*?)\]/);
                if (matches && matches.length > 1) {
                    var fieldName = matches[1];
                    formData[fieldName] = input.value;
                }
            }
            });
            
            if(formType && formType.value === 'customer') {
            dataLayer.push({ event: self.eventPrefix + 'newsletter_signup', ...formData});
            } else if(formType && formType.value === 'contact') {
            dataLayer.push({ event: self.eventPrefix + 'contact_form_submit', ...formData});
            }
        }
        });

    }

    // phone_number_click event
    phoneClickData() {
        const self = this; 
        document.addEventListener('click', function(event) {
        let target = event.target.closest('a[href^="tel:"]');
        if(target) {
            let phone_number = target.getAttribute('href').replace('tel:', '');
            dataLayer.push({
            event: self.eventPrefix + 'phone_number_click',
            page_location: window.location.href,
            link_classes: target.getAttribute('class'),
            link_id: target.getAttribute('id'),
            phone_number
            })
        }
        });
    }

    // email_click event
    emailClickData() {
        const self = this; 
        document.addEventListener('click', function(event) {
        let target = event.target.closest('a[href^="mailto:"]');
        if(target) {
            let email_address = target.getAttribute('href').replace('mailto:', '');
            dataLayer.push({
            event: self.eventPrefix + 'email_click',
            page_location: window.location.href,
            link_classes: target.getAttribute('class'),
            link_id: target.getAttribute('id'),
            email_address
            })
        }
        });
    }
    } 
    // end premium_Shopify_DataLayer

    document.addEventListener('DOMContentLoaded', function() {
    try{
        new premium_Shopify_DataLayer();
    }catch(error) {
        console.log(error);
    }
    });

})();